import React, { useContext } from 'react';

import { RicosViewerContext } from './../../ricos-context';
import type { ButtonData } from './../../ricos-schema/legacy/wix/rich_content/v1';
import type { NodeViewRendererProps } from './../../ricos-types';

import styles from '../statics/styles/default-styles-scss';
import { ACTION_BUTTON_TYPE, LINK_BUTTON_TYPE } from '../types';
import { ButtonViewer } from './button-viewer';

const Button = ({ node, nodeIndex, NodeViewContainer }: NodeViewRendererProps) => {
  const { helpers, config, onNodeClick, baseUrl } = useContext(RicosViewerContext);
  const settings =
    node.buttonData?.type === 'ACTION' ? config[ACTION_BUTTON_TYPE] : config[LINK_BUTTON_TYPE];
  return (
    <NodeViewContainer key={node.id} node={node} nodeIndex={nodeIndex}>
      <ButtonViewer
        nodeId={node.id}
        helpers={helpers}
        settings={settings}
        buttonData={node.buttonData as ButtonData}
        onClick={() => onNodeClick?.({ node })}
        baseUrl={baseUrl}
        className={styles.button_margin}
      />
    </NodeViewContainer>
  );
};

export default Button;
